var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePeapDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_5733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51614 12.2249C1.57735 13.0415 2.19801 13.7173 3.00507 13.856C3.84459 14.0003 4.71102 14.1388 5.59695 14.1388C6.48289 14.1388 7.34932 14.0003 8.18884 13.856C8.99589 13.7173 9.61655 13.0415 9.67775 12.2249C9.78659 10.7729 9.9082 9.26268 9.9082 7.7123C9.9082 6.16191 9.78659 4.65172 9.67775 3.19972C9.61655 2.38313 8.99589 1.70726 8.18884 1.56857C7.34932 1.4243 6.48289 1.28577 5.59695 1.28577C4.71102 1.28577 3.84459 1.4243 3.00507 1.56857C2.19801 1.70726 1.57735 2.38313 1.51614 3.19972C1.40731 4.65172 1.28571 6.16191 1.28571 7.7123C1.28571 9.26268 1.40731 10.7729 1.51614 12.2249Z",
    stroke: "#4A57DA",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3222 20.8004C14.3834 21.6171 15.0041 22.2928 15.8112 22.4315C16.6507 22.5759 17.5171 22.7144 18.403 22.7144C19.289 22.7144 20.1554 22.5759 20.9949 22.4315C21.802 22.2928 22.4227 21.6171 22.4839 20.8004C22.5927 19.3484 22.7143 17.8383 22.7143 16.2879C22.7143 14.7375 22.5927 13.2273 22.4839 11.7753C22.4227 10.9587 21.802 10.2828 20.9949 10.1441C20.1554 9.99986 19.289 9.86133 18.403 9.86133C17.5171 9.86133 16.6507 9.99986 15.8112 10.1441C15.0041 10.2828 14.3834 10.9587 14.3222 11.7753C14.2134 13.2273 14.0918 14.7375 14.0918 16.2879C14.0918 17.8383 14.2134 19.3484 14.3222 20.8004Z",
    stroke: "#4A57DA",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1557 4.30918C14.2794 5.10345 14.9915 5.6892 15.7939 5.73809C16.6388 5.78957 17.5111 5.83934 18.403 5.83934C19.295 5.83934 20.1674 5.78959 21.0122 5.73809C21.8146 5.6892 22.5268 5.10345 22.6505 4.30918C22.6888 4.06371 22.7143 3.81463 22.7143 3.56254C22.7143 3.31048 22.6888 3.06139 22.6505 2.81592C22.5268 2.02166 21.8146 1.43591 21.0122 1.38701C20.1674 1.33552 19.295 1.28577 18.403 1.28577C17.5111 1.28577 16.6388 1.33552 15.7939 1.38701C14.9915 1.43591 14.2794 2.02166 14.1557 2.81592C14.1174 3.06139 14.0918 3.31048 14.0918 3.56254C14.0918 3.81463 14.1174 4.06371 14.1557 4.30918Z",
    stroke: "#4A57DA",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34955 21.1842C1.47328 21.9784 2.18541 22.5642 2.98777 22.6131C3.83269 22.6647 4.70493 22.7144 5.59695 22.7144C6.48896 22.7144 7.36122 22.6647 8.20612 22.6131C9.00848 22.5642 9.72062 21.9784 9.84434 21.1842C9.88257 20.9387 9.9082 20.6896 9.9082 20.4376C9.9082 20.1855 9.88257 19.9364 9.84434 19.6909C9.72062 18.8967 9.00848 18.3109 8.20612 18.262C7.36122 18.2106 6.48896 18.1609 5.59695 18.1609C4.70493 18.1609 3.83269 18.2106 2.98777 18.262C2.18541 18.3109 1.47328 18.8967 1.34955 19.6909C1.31132 19.9364 1.28571 20.1855 1.28571 20.4376C1.28571 20.6896 1.31132 20.9387 1.34955 21.1842Z",
    stroke: "#4A57DA",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_5733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePeapDashboard);
export default __webpack_public_path__ + "static/media/ActivePeapDashboard.46bd48a43dbb6200f95fcbe6311bb234.svg";
export { ForwardRef as ReactComponent };